import { CatalogRouting } from '@aipb/gulliver/catalog/routing';
import { AuthService } from '@aipb/shared/auth';
import { InsideLoadingComponent } from '@aipb/shared/ui/loading';
import { baseUrl } from '@aipb/shared/util/routing';

import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'aipb-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: true,
  imports: [InsideLoadingComponent]
})
export class LoginComponent implements OnInit {
  constructor(private auth: AuthService, private catalogRouting: CatalogRouting) {}

  ngOnInit(): void {
    if (this.auth.isLoggedIn()) {
      this.catalogRouting.searchDefault();
    } else {
      this.auth.login({
        redirectUri: baseUrl()
      });
    }
  }
}
